import { useState, useEffect } from 'react';
import { Gallery } from "react-grid-gallery";
import Lightbox from "yet-another-react-lightbox";
import Button from "react-bootstrap/Button";
import "yet-another-react-lightbox/styles.css";
import { db } from "../../firebase";
import { ref, child, get } from "firebase/database";

const dbRef = ref(db);

const Post = () => {

    const [imagesNew, setImages] = useState([]);
    const [index, setIndex] = useState(-1);
    const [currentFilter, setCurrentFilter] = useState('Bedroom');

    useEffect(() => {
        populateData();
    }, []);

    async function populateData() {
        get(child(dbRef, `images`)).then((snapshot) => {
            if (snapshot.exists()) {
                let data = []
                snapshot.forEach(node => {
                    let caption = node.val().caption;
                    let src = node.val().src;
                    let width = 600;
                    let height = 400;
                    data = [...data, { caption, src, width, height }]
                })
                setImages([...imagesNew, ...data]);
            } else {
                console.log("No data available");
            }
        }).catch((error) => {
            console.error(error);
        });
    }

    const handleFilterChange = (filter) => {
        setCurrentFilter(filter);
    }; 

    const handleClick = (index, item) => setIndex(index);

    const filteredImages = currentFilter ? imagesNew.filter(image => image.caption === currentFilter) : imagesNew;

    const slides = filteredImages.map(({ src, width, height }) => ({
        src,
        width: 1600,
        height: 800,
    }));


    return (
        <div>
            <div style={{ marginBottom: '10px' }}>
                <Button
                    variant="primary"
                    onClick={() => handleFilterChange('Bedroom')}
                    style={{ marginRight: '10px', marginTop: '10px' }}
                >&nbsp;Bedroom
                </Button>
                <Button
                    variant="primary"
                    onClick={() => handleFilterChange('Living Room')}
                    style={{ marginRight: '10px', marginTop: '10px' }}
                >&nbsp;Living Room
                </Button>
                <Button
                    variant="primary"
                    onClick={() => handleFilterChange('Kitchen')}
                    style={{ marginRight: '10px', marginTop: '10px' }}
                >&nbsp;Kitchen
                </Button>
                <Button
                    variant="primary"
                    onClick={() => handleFilterChange('Site Execution')}
                    style={{ marginRight: '10px', marginTop: '10px' }}
                >&nbsp;Site Execution
                </Button>
                <Button
                    variant="primary"
                    onClick={() => handleFilterChange('2D Design')}
                    style={{ marginRight: '10px', marginTop: '10px' }}
                >2D Design
                </Button>
            </div>
            <Gallery
                images={filteredImages}
                onClick={handleClick}
                enableImageSelection={false}
            />
            <Lightbox
                slides={slides}
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
            />
        </div>
    );
};

export default Post;
